import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import ObjectOverride from "components/ObjectOverride";
import {Button} from "reactstrap";
import {Objects} from "../index";
import UniversalModalOverride from "../UniversalModalOverride";
import APPCONFIG from "../../constants/Config";
import API from "@beardeddevops/react.api"

/**
 *  @property {Accounts_Customizations_Object} state
 *  @property {object} model
 *  @property {Accounts_Customizations_Properties} model.properties
 *  @property {Accounts_Customizations_Is} model.is
 *  @property {Accounts_Customizations_Has} model.has
 */
class AccountCustomizations extends ObjectOverride {
	static propTypes = {
		...Framework.Components.Object.propTypes,
	};

	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
		this.state.showApiKeyError = '';
		this.state.showApiKey = false;
		this.state.crmExportType = 'all';
	}

	//CRM Customer Export: navigate the browser directly to the streamed CSV endpoint (B7).
	//Mirrors the proven in-repo pattern (Custom_Export_2669 / Custom_Export_2669-style anchor links).
	handleCrmExport = (type) => {
		let exportType = type || this.state.crmExportType || 'all';
		let url = `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/customers/export?export_type=${exportType}`;
		window.open(url, '_blank', 'noopener,noreferrer');
	}

	/**
	 * @param prevProps
	 * @param {Accounts_Customizations_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	pendingComplete = (data) => {
		this.state.account_signature = data.account_signature;
		this.update = 'POST_SIGNATURE';
		this.handleSubmit().then();
		this.setState({signature: true});
	};

	downloadPDFs = async () => {
		let zip_bound_book_queue = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, API.RequestType.CREATE);
		zip_bound_book_queue.object.zip_file = true;
		zip_bound_book_queue.parent = this.props.id ? this.props.id : 0;

		const firstUnarchivedLocation = this.props.rootState.locations.find(location => location.archived === false);
		zip_bound_book_queue.grandparent = firstUnarchivedLocation.binary_id + '-' + firstUnarchivedLocation.pkey;
		zip_bound_book_queue.object.location_binary_id = firstUnarchivedLocation.binary_id;
		zip_bound_book_queue.object.location = firstUnarchivedLocation.pkey;
		let result = await zip_bound_book_queue.submit(null, API.RequestType.CREATE);

		this.props.history.push(`/locations/${firstUnarchivedLocation.binary_id}-${firstUnarchivedLocation.pkey}#downloads`);

	}

	generateAccountPDFs = async () => {
		let pdfModel = new API.BuildClass(Types.Forms_Results._name, 'GET_ALL_ACCOUNT_FORMS_INTO_SERVER');
		let res = await pdfModel.submit(this, 'GET_ALL_ACCOUNT_FORMS_INTO_SERVER');
	}

	openApiDocs = () => {
		const apiBaseUrl = APPCONFIG.settings.apiURL();
		const apiVersion = APPCONFIG.settings.apiVersion;
		const docsUrl = `${apiBaseUrl}/${apiVersion}/docs`;
		window.open(docsUrl, "_blank", "noopener,noreferrer");
	}

	afterSubmit = () => {
		window.location.reload();
	}


	handlePosLink = async () => {
		this.setState({loading: true})
		let linkModel = new API.BuildClass(Types.Accounts_Customizations._name, 'POST_LINK_FFLBOSS_POS')
		linkModel.object.pos_username = this.state.pos_username;
		linkModel.object.pos_password = this.state.pos_password;
		try {
			let result = await linkModel.submit(null, 'POST_LINK_FFLBOSS_POS');
			if(result) {
				//Need to do this correctly

				this.props.history.push('/')
				this.props.history.push('/accounts#customizations')
			}
			this.setState({loading: false})
		} catch (e) {
			this.setState({loading: false})
		}

	}


	handlePosUnlink = async () => {
		this.setState({loading: true})
		let linkModel = new API.BuildClass(Types.Accounts_Customizations._name, 'POST_UNLINK_FFLBOSS_POS')
		let result = await linkModel.submit(null, 'POST_UNLINK_FFLBOSS_POS')
		if(result) {
			//Need to do this correctly
			this.props.history.push('/')
			this.props.history.push('/accounts#customizations')
		}
		this.setState({loading: false})

	}

	form = () => {
		/** @type {Accounts_Customizations_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Customizations_Object} object */
		let object = this.state;
		// console.log('this inform', this.state);
		return (
			<>
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<div className={"row"}>
							<div className={"col-md"}>
								<Objects.DropBoxConnect
									url={'accounts#customizations'}
								/>

								{/*This is a dev only thing, that is used if someone pays to back generate PDFs*/}
								{/*{this.props.rootState.account_number === 1 ?*/}
								{/*	<div>*/}
								{/*		<h4 className="section-title">PDF Generator</h4>*/}
								{/*		<div className="form-group">*/}
								{/*			Generate all pdfs onto the server*/}
								{/*		</div>*/}
								{/*		<div className="form-group">*/}
								{/*			/!*show button if no refresh token, else show text that its connected and possibly how to disconnect*!/*/}
								{/*			<Button color="success" onClick={this.generateAccountPDFs}>PDF Generator</Button>*/}

								{/*		</div>*/}
								{/*	</div> : null}*/}
								<h4 className={"section-title"}>
									POS Account Linking
									{object.pos_pkey && (
										<span style={{color: '#28a745', marginLeft: '10px'}}>
											✓ Linked
										</span>
									)}
								</h4>

								{object.pos_pkey ?
									<>
									<Button color="danger" onClick={this.handlePosUnlink}>
										Unlink Accounts
									</Button>
									<div className="row" style={{marginTop: '20px'}}>
										<div className="col-9">
											<span className="input-label">Sync Customers to FFL Boss POS</span>
										</div>
									<Framework.Elements.ButtonSwitch
										property={properties.pos_customer_copy}
										value={object.pos_customer_copy}
										error={object.pos_customer_copy_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
									/>
									</div>

									</>
									:
									<>
										<div className="form-group">
											<Framework.Elements.TextField
											label={"FFL Boss POS Username"}
											value={object.pos_username}
											error={object.pos_username_error}
											property={properties.pos_username}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<br/>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"FFL Boss POS Password"}
											value={object.pos_password}
											error={object.pos_password_error}
											property={properties.pos_password}
											update={this.handleTextFieldPropertyUpdate}
											type={"password"}
										/>
									</div>
									<br/>
									<div className="form-group">
										<Button color="green-meadow" onClick={this.handlePosLink}>
											Link Accounts
										</Button>
									</div>
									</>
								}

							</div>

							<div className={"col-md"}>
								<div>
									<h4 className="section-title">Show Side Navigation Arrows</h4>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.arrow_setting}
											value={object.arrow_setting}
											error={object.arrow_setting_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
										</div>
										</div>
										{object.force_4473_fields_available &&
											<div>
												<h4 className={"section-title"}>Kiosk 4473 Required Fields</h4>
												<div className="form-group">
													<Framework.Elements.ButtonSwitch
														property={properties.force_4473_fields}
														value={object.force_4473_fields}
														error={object.force_4473_fields_error}
														update={this.handleTextFieldPropertyUpdate}
														labelTrue={'Required'}
														labelFalse={'Optional'}
													/>
												</div>
												<div className="text-muted" style={{fontSize: '0.85rem', marginTop: '4px'}}>
													Require SSN, phone number, email, and UPIN on kiosk 4473s. Only customers subscribed to the Kiosk Required Fields module can enable this.
												</div>
											</div>}
										{(this.props.rootState && this.props.rootState.crmAvailable) &&
										<div>
											<h4 className={"section-title"}>CRM Customer Export</h4>
											<div className="form-group" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
												<select
													className="form-control"
													style={{width: '280px', flexShrink: 0}}
													value={this.state.crmExportType}
													onChange={(e) => this.setState({crmExportType: e.target.value})}
												>
													<option value="all">All customers</option>
													<option value="email">All customers with email</option>
													<option value="sms">All customers with text opt-ins</option>
													<option value="both">All customers with both</option>
												</select>
												<Button color="primary" onClick={() => this.handleCrmExport(this.state.crmExportType)}>
													Export
												</Button>
											</div>
											<div className="text-muted" style={{fontSize: '0.85rem', marginTop: '4px'}}>
												Downloads a CSV of customer names, contact info, address (incl. country), language, email/SMS opt-ins with audit dates, and last-contact date.
											</div>
										</div>}
										{this.state.fflboss_api_key_unhashed &&
									<div>
										<h4 className="section-title">FFLBoss API Key</h4>

										{/* API Key Toggle */}
										<div className="form-group">
											<div className="row">
												<div className="col-6">
													<span className="input-label">Show API Key</span>
												</div>
												<div className="col-6 text-right">

													<Button
														color={this.state.showApiKey ? "success" : "secondary"}
														size="sm"
														style={{
															borderRadius: "20px",
															paddingLeft: "18px",
															paddingRight: "18px",
															transition: "0.2s",
														}}
														onClick={() =>
															this.setState({ showApiKey: !this.state.showApiKey })
														}
													>
														{this.state.showApiKey ? "On" : "Off"}
													</Button>

												</div>
											</div>
										</div>

										{this.state.showApiKey && (
											<div className="form-group" style={{ marginTop: "10px" }}>
												<div
													style={{
														padding: "10px",
														background: "#f5f5f5",
														borderRadius: "5px",
														fontFamily: "monospace",
														wordBreak: "break-all",
													}}
												>
													{this.state.fflboss_api_key_unhashed}
												</div>
											</div>
										)}
										<div className="form-group" style={{ marginTop: "10px" }}>
											<Button color="info" onClick={this.openApiDocs}>
												View API Docs
											</Button>
										</div>
									</div>
								}


								{this.props.rootState.hasPawnModule &&
									<div>
										<h4 className="section-title">Pawn Customizations</h4>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Pawn Inventory"}
												value={object.inventory}
												error={object.inventory_error}
												property={properties.inventory}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Pawn Ticket"}
												value={object.ticket}
												error={object.ticket_error}
												property={properties.ticket}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>}
								{this.props.rootState.hasImporterModule &&
									<div>
										<h4 className="section-title">Account Signature (Used only for Importer Module)</h4>
										<div className="form-group">
											{object.signature ? "You have an account signature" : "You do not have an account signature"}
										</div>
										<div className="form-group">
											<Button color="green-meadow" onClick={() => this.setState({accountSign: !this.state.accountSign})}>Change
												Account
												Signature</Button>
										</div>
									</div>}

							</div>
						</div>

						<UniversalModalOverride
							name={"Signature"}
							locations={this.props.locations}
							states={this.props.states}
							kiosks={this.props.kiosks}
							history={this.props.history}
							object={Objects.AccountSign}
							toggle={this.state.accountSign}
							size={"lg"}
							afterSave={this.pendingComplete}
							reportClose={this.reportClose('accountSign')}
						/>

					</CardContent>
					<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>

				</Card>
			</>
		)
	}

	render() {
		//TODO: would be cool to make this a popup that you can show elsewhere in the future

		// let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		// if (hasModal) {
		// 	return this.form();
		// }

		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>

				<CardActions style={{justifyContent: 'end', padding: '14px'}}>
					<Button color="primary" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(AccountCustomizations);
